import React, { Component } from 'react';
import { Row, Col, Panel, PanelGroup, Table } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";

import { BusquedaEst } from "../../funciones/HistoricoFunction";
import { NotificacionesValid } from '../../funciones/NotificacionesFunction';

import EstudiantesList from "./HistoricoContent/EstudiantesList";
import HistoricoEst from "./HistoricoContent/HistoricoEst";

let componente = 0;
class Historico extends Component {
    state = {
        string: "",
        preloader: "",
        textSearch: <div align="center">Para agregar o modificar algún archivo histórico ingresa un dato del estudiante y presiona Enter.</div>,
        datEstReg: [],
        datEstEgr: [],
        datNoIns: [],
        idEst: [],
        btnDown: true,
        iconChevron: "fa fa-chevron-down",
        solicitudes: [],
        carrerasEst: [],
        activeKey: false,
        solicitudesL: <i className="fa fa-spinner fa-spin"></i>,
        textEstPendientes: "Cargando Listado"
    }

    constructor (props) {
        super (props);

        NotificacionesValid  ((resp) => {
            let solic = 0;

            for (let i in resp[0]) {
                if (resp[0][i].t_name === "EST") solic++;
            }

            if (resp[0] === 0) {
                this.setState({
                    textEstPendientes: "No existen perfiles pendientes por aprobar",
                    solicitudes:resp[0],
                    carrerasEst: resp [1],
                    solicitudesL: solic
                })
            }else{
                this.setState({
                    solicitudes:resp[0],
                    carrerasEst: resp [1],
                    solicitudesL: solic
                })
            }
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    componentWillUnmount = () => {
        componente = 0;
    }

    enterTab = () => (e) => {
        if (e.which === 13){
            if (this.state.string === "") return null;
            this.setState ({
                preloader: "fa fa-spinner fa-spin",
                textSearch: <div align="center"><i className="fa fa-spinner fa-spin"></i> Buscando estudiantes, espera por favor</div>,
            }, () => {
                BusquedaEst (this.state.string, (resp) => {
                    if (resp[0].length === 0 && resp[1].length === 0 && resp[2].length === 0){
                        componente = 0;
                        this.setState ({
                            preloader: "",
                            textSearch: <div align="center">La búsqueda no obtuvo ningún resultado</div>,        
                        });
                    }else{
                        componente = 1;  
                        this.setState ({
                            datEstReg: resp[0],
                            datEstEgr: resp[1],
                            datNoIns: resp[2],
                            preloader: "",
                            textSearch: <div align="center">Para agregar o modificar algún archivo histórico ingresa un dato del estudiante y presiona Enter.</div>,
                        });
                    }
                })
            });
        }
    }

    ayuda = () => (
        <React.Fragment>
            <div align="justify">
                Mediante este módulo podrás agregar las calificaciones históricas de los estudiantes regulares como los egresados. Para esto debes realizar los siguientes pasos:
            </div>
            <Row>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                </Col>
                <Col md={12} align="justify">
                    Ingresa un dato del estudiante a consultar (cédula, nombre o apellido)
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Verás tres listados con todas las coincidencias de tu búsqueda (Estudiantes Regulares, Estudiantes no Inscritos y Estudiantes Egresados y/o Retirados)con los siguientes datos:
                </Col>
                <Col md={12} align="justify" className="custom-mt-10" style={{paddingLeft:30, paddingRight:30, fontSize: 10}}>
                    <div><strong>C.I.</strong> Cédula del Estudiante</div>
                    <div><strong>Estudiante</strong> Nombres y Apellidos</div>
                    <div><strong>Carrera</strong> Carrera Inscrita</div>
                    <div><strong>Acciones</strong> Botón de Acciones</div>
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    <strong style={{fontSize:11}}>También puedes seleccionar a un estudiante del listado de solicitudes pendientes (en caso de haber) haciendo Click en: </strong>
                    <div className="custom-alert-info custom-color" align="center"><strong style={{fontSize:10}}>Solicitud de Aprobación de Perfiles</strong> <i className="fa fa-chevron-down"></i></div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                </Col>
                <Col md={12} align="justify">
                    Una vez seleccionado el estudiante presiona el botón <button className="btn btn-xs btn-primary" style={{borderWidth:1}}><i className="fa fa-gear"></i> Ver Histórico</button> el cual te mostrará los datos del estudiante y sus carreras registradas.
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
                </Col>
                <Col md={12} align="justify">
                    Despliega el recuadro con la carrera a modificar hacienciendo <strong>Click</strong> en la carrera:
                    <div className="custom-alert-info custom-color" align="center"><strong style={{fontSize:10}}>DISEÑO GRÁFICO</strong> <i className="fa fa-chevron-down"></i></div>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Podrás ver toda la información correspondiente a los periodos registrados en la carrera que seleccionaste
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 4:</strong>
                </Col>
                <Col md={12} align="justify">
                    Selecciona un periodo disponible que te abrirá una ventana con las asignaturas.
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Una vez agregado el histórico de cada periodo puedes modificarlo seleccionando nuevamente dicho semestre o haciendo <strong>Click</strong> en el botón <button className="btn btn-xs btn-primary" style={{borderWidth:1}}><i className="fa fa-gear"></i> Acciones</button> que te permitirá Editar o Eliminar el histórico del periodo seleccionado
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <span className="text-primary"><i className="fa fa-plus-square"></i> Calificación (Mat. Aplazada):</span>
                </Col>
                <Col md={12} align="justify">
                    Mediante esta opción puedes agregar nuevas calificaciones de las asignaturas aplazadas en el archivo histórico
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Carga Automatizada</strong>
                </Col>
                <Col md={4} className="custom-mt-10">
                    <button className="btn btn-success btn-xs" style={{borderWidth: 1, fontSize: 8}}><i className="fa fa-file-excel-o"></i> Cargar Archivo</button>
                </Col>
                <Col md={8} className="custom-mt-10" align="justify">
                    Mediante este botón podrás seleccionar el archivo de calificaciones del estudiante y se cargarán las notas que cumplan con todos los campos requeridos de forma automática
                </Col>
                <Col md={4} className="custom-mt-10">
                    <button className="btn btn-warning btn-xs" style={{borderWidth: 1, fontSize: 8}}><i className="fa fa-search"></i> Ver Celdas</button>
                </Col>
                <Col md={8} className="custom-mt-10" align="justify">
                    Este botón permite definir el nombre de las celdas que son equivalentes del histórico y el nombre de la hoja dentro del archivo .xls
                    <div style={{fontSize: 10}}><strong>Importante: Esta función es delicada y puede ocasionar la pérdida de los datos históricos del estudiante si no se usa con cuidado.</strong></div>
                </Col>
            </Row>
        </React.Fragment>
    )

    cambiaComponente = (id) => {
        componente = 2;
        this.setState({ idEst: id })
    }

    contenido = () => {
        let { textSearch, idEst, datEstReg, datEstEgr, datNoIns } = this.state;
        switch (componente) {
            case 1:
                return (<EstudiantesList regulares= {datEstReg} egresados= {datEstEgr} noInscritos = {datNoIns}
                        funcion = { (id) => {this.cambiaComponente(id)} }/>)
            case 2:
                return (<HistoricoEst est = {idEst}/>)
            default:
                return (<div className="custom-mt-10 custom-color">{textSearch}</div>)
        }
    }

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    EstSolicitudes = () => {
        let { solicitudes, carrerasEst, textEstPendientes } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let abrirHistorico = (id) => (e) => {
            this.setState({
                activeKey: false,
                btnDown: true,
                iconChevron: "fa fa-chevron-down",
            }, () => {
                this.cambiaComponente(id)
            })
        }

        let semestre = (id, tipo) => {
            const resultado = carrerasEst.find( (estudiante) => estudiante.User_Id === id );
            if(tipo === "EST")return(
                <div><strong>{resultado.Carrera}</strong></div>
            )
            return null;
        }

        let listEst = () => {
            let contenido = [];

            for (let i in solicitudes) {
                if (solicitudes[i].t_name === "EST"){
                    contenido.push(
                        <tr key={solicitudes[i].id}>
                            <td style={styles}>{`${solicitudes[i].nacionalidad} ${solicitudes[i].ci}`}</td>
                            <td style={styles}>{nombre(solicitudes[i].nombre_1, solicitudes[i].nombre_2, solicitudes[i].apellido_1, solicitudes[i].apellido_2)}</td>
                            <td align="center" style={styles}>{semestre(solicitudes[i].id, solicitudes[i].t_name)}</td>
                            <td align="center" style={styles}>
                                <button onClick={abrirHistorico(
                                    {
                                        id: solicitudes[i].id,
                                        ci: `${solicitudes[i].nacionalidad} ${solicitudes[i].ci}`,
                                        nombre: nombre(solicitudes[i].nombre_1, solicitudes[i].nombre_2, solicitudes[i].apellido_1, solicitudes[i].apellido_2)
                                    }
                                )} style={{borderWidth: 1}} className="btn btn-primary"><i className="fa fa-gear"></i> Ver Histórico</button> 
                            </td>
                        </tr>
                    )
                }
            }

            if (contenido.length === 0) return(
                <tr><td colSpan={4} align="center">{textEstPendientes}</td></tr>
            )

            return contenido;
        }

        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF", overflowY: "auto", maxHeight: 300}}>
                <Table striped hover bordered>
                    <tbody>
                        <tr className="custon-back-color">
                            <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                            <td width="50%" style={styles}><strong>Estudiante</strong></td>
                            <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                            <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                        </tr>
                        {listEst()}
                    </tbody>
                </Table>
            </div>
        )
    }

    solicitudes = () => (
        <Panel eventKey = {true} onClick = {()=> {
            this.setState({
                activeKey:!this.state.activeKey
            }, () => {
                NotificacionesValid  ((resp) => {
                    let solic = 0;

                    for (let i in resp[0]) {
                        if (resp[0][i].t_name === "EST") solic++;
                    }

                    if (resp[0] === 0) {
                        this.setState({
                            textEstPendientes: "No existen perfiles pendientes por aprobar",
                            solicitudes:resp[0],
                            carrerasEst: resp [1],
                            solicitudesL: solic
                        })
                    }else{
                        this.setState({
                            solicitudes:resp[0],
                            carrerasEst: resp [1],
                            solicitudesL: solic
                        })
                    }
                })
            })}} style={{marginBottom:5, marginTop: 5}}>
            <Panel.Heading>
                <Panel.Title toggle className="custom-color" onClick={this.cambiaIcon}>
                    <Row>
                        <Col md={10} style={{fontSize: 12}}>
                            <strong>Solicitudes de Aprobación de Perfiles ({this.state.solicitudesL})</strong>
                        </Col>
                        <Col md={2} align="right">
                            <i className={this.state.iconChevron}></i>
                        </Col>
                    </Row>
                </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                {this.EstSolicitudes()}
            </Panel.Body>
        </Panel>
    )

    render() {
        let { string, preloader } = this.state;

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <PanelGroup accordion activeKey={this.state.activeKey} className="custom-alert-info" id="solicHist">
                            {this.solicitudes()}
                        </PanelGroup>
                        <div className="custom-alert-success" style={{padding: 5, marginBottom: 20}}>
                            <div>Búsqueda de Estudiantes <i className={preloader}></i></div>
                            <input type="text" value ={string} onChange={this.cambiaValor("string")} onKeyPress={this.enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Archivo Histórico</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Historico;


// WEBPACK FOOTER //
// ./src/views/Registros/Historico.jsx